module.exports = __webpack_public_path__ + "static/media/chickenfiesta.2ed70043.jpg";